import { type ClassValue } from "clsx";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Tailwind + clsx merge utility used across UI components
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}
